import { Switch, Route, Redirect } from 'react-router-dom';
import Home from './pages/Home';
import Tables from './pages/Tables';
import Billing from './pages/Billing';
import Rtl from './pages/Rtl';
import Profile from './pages/Profile';
import SignUp from './pages/SignUp';
import SignIn from './pages/SignIn';
import Detail from './pages/Detail';
import Main from './components/layout/Main';
import Download from './pages/Download';
import Order from './pages/Order';
import 'antd/dist/antd.css';
import './assets/styles/main.css';
import './assets/styles/responsive.css';
import Analytics from './pages/Analytics';
import Spec from './pages/Spec';
import { useLocalStorage } from 'src/hooks/useLocalStorage';
import { useEffect, useState } from 'react';
import { verifyToken } from 'src/services/auth.service';
import { Spin } from 'antd';
import instance from './services/instance';

const PrivateRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [accessToken, setAccessToken] = useLocalStorage('access_token');
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  useEffect(() => {
    const verifyAccessToken = async () => {
      try {
        if (!accessToken) throw new Error('No access token found');
        await verifyToken(accessToken);
        instance.setToken(accessToken);
        setIsAuthenticated(true);
      } catch (error) {
        console.error('Token verification failed:', error);
        // Try to refresh the token using refresh_token from cookie
        try {
          const response = await instance.post(
            '/refresh',
            {},
            {
              withCredentials: true, // Ensure cookies are sent with the request});
            }
          );
          const newAccessToken = response.data.access_token;
          if (newAccessToken) {
            setAccessToken(newAccessToken);
            instance.setToken(newAccessToken);
            setIsAuthenticated(true);
          } else {
            setAccessToken(null);
          }
        } catch (refreshError) {
          console.error('Token refresh failed:', refreshError);
          setAccessToken(null);
          window.location.href = '/sign-in';
        }
      } finally {
        setLoading(false);
      }
    };
    verifyAccessToken();
    const interval = setInterval(
      verifyAccessToken,
      process.env.REACT_APP_TOKEN_REFRESH_INTERVAL || 30 * 60 * 1000
    );
    return () => clearInterval(interval);
  }, [accessToken, setAccessToken]);

  if (loading)
    return (
      <Spin tip='Loading...' size='large' style={{ margin: '20px 20px' }} />
    );
  else return isAuthenticated ? children : <Redirect to='/sign-in' />;
};

function App() {
  return (
    <div className='App'>
      <Switch>
        <Route path='/sign-up' exact component={SignUp} />
        <Route path='/sign-in' exact component={SignIn} />
        <PrivateRoute>
          <Main>
            <Route exact path='/dashboard' component={Home} />
            <Route exact path='/analytics' component={Analytics} />
            <Route exact path='/tables' component={Tables} />
            <Route exact path='/billing' component={Billing} />
            <Route exact path='/rtl' component={Rtl} />
            <Route exact path='/profile' component={Profile} />
            <Route path='/account/:accountName' component={Detail} />
            <Route path='/spec/:specName' component={Spec} />
            <Route path='/download' component={Download} />
            <Route path='/order' component={Order} />
            <Redirect from='*' to='/dashboard' />
          </Main>
        </PrivateRoute>
      </Switch>
    </div>
  );
}

export default App;
